import { makeStyles } from '@mui/styles';
import Table from 'apollo-react/components/Table';
import React, { useEffect, useState } from 'react';

import ExpandableComponent from './ExpandableComponent';
import ExpandCollapseCell from './ExpandCollapseCell';
import NavigationCell from './NavigationCell';
import DateCell from '../../../../components/CommonTableCells/DateCell';
import { useFormSelector } from '../../../../custom-hooks';
import { useTranslation } from '../../../../custom-hooks/useTranslation';
import { FORM_CHANGES_TABLE_TYPES } from '../../../constants/runtime.constants';
import {
  getFormChangesTableRows,
  getIsFormChangesTableLoading,
} from '../../../selectors/common.selectors';

const useStyles = makeStyles({
  root: {
    margin: '12px 0',

    '& [class*="MuiTableHead-root"]': {
      border: '1px solid #e9e9e9',
    },
    '& [class*="MuiTable-root"]': {
      border: '1px solid #e9e9e9',
    },
  },
});

const FormChangesTable = ({ type, collapseBlade }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const rows = useFormSelector(getFormChangesTableRows);
  const isLoading = useFormSelector(getIsFormChangesTableLoading);

  const [expandedRow, setExpandedRow] = useState(null);

  useEffect(() => {
    setExpandedRow(null);
  }, [type]);

  const deletedFieldsColumns = [
    {
      header: translateString('Control Type'),
      accessor: 'controlType',
    },
    {
      header: translateString('Data Member'),
      accessor: 'entityName',
    },
    {
      header: translateString('Data Field'),
      accessor: 'fieldName',
    },
    {
      header: translateString('Form Name'),
      accessor: 'containerFormName',
    },
    {
      header: translateString('Form Last Modified'),
      accessor: 'formLastModified',
      customCell: DateCell,
    },
  ];

  const addedAndMovedFieldsColumns = [
    ...deletedFieldsColumns,
    {
      header: '',
      accessor: 'navigation',
      width: 40,
      customCell: NavigationCell,
    },
  ];

  const modifiedFieldsColumns = [
    ...deletedFieldsColumns,
    {
      header: '',
      accessor: 'navigation',
      width: 40,
      customCell: NavigationCell,
    },
    {
      header: '',
      accessor: 'expandCollapse',
      width: 40,
      customCell: ExpandCollapseCell,
    },
  ];

  const columns =
    type === FORM_CHANGES_TABLE_TYPES.MODIFIED
      ? modifiedFieldsColumns
      : type === FORM_CHANGES_TABLE_TYPES.DELETED
      ? deletedFieldsColumns
      : addedAndMovedFieldsColumns;

  return (
    <div className={classes.root}>
      <Table
        columns={columns}
        rows={rows[type].map((row) => ({
          ...row,
          expanded: row.rowId === expandedRow,
          setExpandedRow,
          collapseBlade,
        }))}
        isLoading={isLoading}
        hidePagination
        ExpandableComponent={ExpandableComponent}
      />
    </div>
  );
};

export default FormChangesTable;
